import { render, staticRenderFns } from "./horario_row_colaborador.vue?vue&type=template&id=4c6d2067&scoped=true&"
import script from "./horario_row_colaborador.vue?vue&type=script&lang=js&"
export * from "./horario_row_colaborador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6d2067",
  null
  
)

export default component.exports